var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMarket(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1895",
    "data-name": "Groupe 1895",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "local_mall_FILL1_wght400_GRAD0_opsz48",
    d: "M17.6,10.681h13.11a5.478,5.478,0,0,0-1.891-4.226,6.691,6.691,0,0,0-4.664-1.713,6.691,6.691,0,0,0-4.664,1.713A5.478,5.478,0,0,0,17.6,10.681Zm6.555,13.706a9.949,9.949,0,0,0,6.908-2.65,8.187,8.187,0,0,0,2.925-6.259H30.96a5.67,5.67,0,0,1-2.017,4.34,7.192,7.192,0,0,1-9.581,0,5.67,5.67,0,0,1-2.017-4.34H14.32a8.187,8.187,0,0,0,2.925,6.259A9.949,9.949,0,0,0,24.153,24.387ZM39.28,40.378H9.025a3.055,3.055,0,0,1-2.118-.822A2.517,2.517,0,0,1,6,37.637V13.422A2.518,2.518,0,0,1,6.908,11.5a3.055,3.055,0,0,1,2.118-.822h5.547a8.158,8.158,0,0,1,2.672-6.145A9.294,9.294,0,0,1,23.9,2a10.205,10.205,0,0,1,6.908,2.536,7.85,7.85,0,0,1,2.925,6.145H39.28A3.055,3.055,0,0,1,41.4,11.5a2.517,2.517,0,0,1,.908,1.919V37.637a2.517,2.517,0,0,1-.908,1.919A3.055,3.055,0,0,1,39.28,40.378Z",
    transform: "translate(-0.153 2.811)",
    fill: "#d0d0d0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1771",
    "data-name": "Rectangle 1771",
    width: 48,
    height: 48,
    transform: "translate(0)",
    fill: "none"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarket);
export default __webpack_public_path__ + "static/media/market.a372ab1f7393cdbd39ec9bff8e428d98.svg";
export { ForwardRef as ReactComponent };